// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"8260f8bf13c3c9998817","678":"3159793addbdd9783b61","883":"0d76e1f2419040efc887"}[chunkId] + ".js";
};